import { render } from "./areaValidationToggle.vue?vue&type=template&id=251ef28e&scoped=true"
import script from "./areaValidationToggle.vue?vue&type=script&lang=js"
export * from "./areaValidationToggle.vue?vue&type=script&lang=js"

import "./areaValidationToggle.vue?vue&type=style&index=0&id=251ef28e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-251ef28e"

export default script